<template>
  <div>
    <!--    <page-header></page-header> -->
    <div>
      <v-row class="ma-0">
        <v-col cols="12" class="px-6 py-5 appr-doc-list-wrap">
          <!-- empty Data component -->
          <empty-data
            v-if="emptyDataFlag"
            v-bind:text="emptyDataText"
          ></empty-data>

          <!-- 설문지 목록 -->
          <v-list v-else flat>
            <v-list-item-group>
              <v-list-item
                :ripple="false"
                v-for="item in searchList"
                :key="item.applSeq"
              >
                <v-card elevation="0" class="doc-box">
                  <v-row class="ma-0">
                    <v-col cols="12" class="pa-0">
                      <v-list-item class="px-0">
                        <v-list-item-icon class="avatar-wrap">
                          <v-avatar color="white" class="with-icon">
                            <!-- 신청서종류 따라 아이콘 변경 -->
                            <appl-menu-icon
                              :propsParam="{
                                applCd: item.applCd,
                                gntGubunCd: item.gubunCd,
                              }"
                              :styleClassStr="'mr-0'"
                            />
                          </v-avatar>
                        </v-list-item-icon>
                        <v-list-item-content class="pa-0">
                          <v-list-item-title
                            class="card-title"
                            style="white-space: normal"
                          >
                            {{ item.surveyNm }}
                          </v-list-item-title>
                          <v-list-item-subtitle class="desc">
                            <span></span> {{ item.surveySYmd }} ~
                            {{ item.surveyEYmd }}
                          </v-list-item-subtitle>
                          <v-list-item-subtitle class="desc">
                            <span>{{
                              item.signYn === 'N' ? '무기명' : '기명'
                            }}</span>
                            <span class="divider"></span>
                            <span>{{
                              item.openYn === 'N' ? '비공개' : '공개'
                            }}</span>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                        <!--div class="arrow-wrap">
                          <v-btn
                            fab
                            text
                            width="24"
                            height="24"
                            color="grey darken-2"
                          >
                            <v-icon size="24">mdi-chevron-right</v-icon>
                          </v-btn>
                        </div-->
                      </v-list-item>
                    </v-col>
                  </v-row>
                  <v-card-actions class="pa-0 mt-4">
                    <v-row align="center" justify="space-around" class="ma-0">
                      <v-btn
                        class="btn-sign"
                        elevation="0"
                        color="deepGrey"
                        @click="openSurvey(item)"
                      >
                        <span class="white--text">
                          <!--v-icon size="18">mdi-check</v-icon-->
                          참여
                        </span>
                      </v-btn>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
/* 내 신청서 리스트 컴포넌트 */
import EmptyData from '@/components/common/EmptyData.vue';
import ApplMenuIcon from '@/components/application/form/ApplMenuIcon.vue';

//import dayjs from 'dayjs';
import messageConstants from '@/const/messageConstants.js';
import { surveyBoxList } from '@/api/allDoc.js';
import { mapGetters } from 'vuex';
import routerNames from '@/const/routerConstants';

export default {
  props: {
    // 조회요청구분 (MYDOC:내문서, TEMP:임시저장문서, CANCEL:취소신청문서)
    searchReqGubun: {
      type: String,
    },
    // 조회신청서코드 (근태취소신청, 보상휴가취소신청일때만 전달)
    searchApplCd: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      emptyDataFlag: false, // 조회결과없음 플래그
      searchList: [],
      emptyDataText: messageConstants.emptyDataMsg_1,
    };
  },
  computed: {
    ...mapGetters('DIALOG', ['GET_DIALOG_CALLBACK']),
  },
  watch: {
    GET_DIALOG_CALLBACK(callback) {
      if (callback) {
        this.fetchMyBoxList();
      }
    },
  },
  methods: {
    async openSurvey(item) {
      this.$store.commit('SET_ITEM', item);
      this.$router.push(routerNames.SurveyAnswer);
    },
    /* 내문서함 목록조회 */
    async fetchMyBoxList() {
      // 조회기준 :
      //  [내문서함] 신청일 기준 최근 한 달 && 모바일에서 사용하는 신청서 && 임시저장상태 제외
      //  [임시저장] 조회기간전체 && 모바일에서 사용하는 신청서 && 임시저장상태만
      //  [취소신청] 신청일 기준 최근 한 달 && 근태취소신청은 근태만, 보상휴가취소신청은 보상휴가만 && 처리완료상태만
      const paramObj = {
        searchBizCd: '05',
      };

      try {
        const response = await surveyBoxList(paramObj);
        console.dir(response);
        const dataList = response.data.data;

        if (dataList.length > 0) {
          this.searchList = dataList;
        }

        // 조회결과없음 플래그값 세팅
        this.emptyDataFlag = this.searchList.length < 1;

        this.$store.commit('SPINNER/OFF_COMMON_SPINNER'); // 공통 스피너 OFF
      } catch (error) {
        console.log(error);
      }
    },
  },
  created() {
    // 공통 스피너 ON
    this.$store.commit('SPINNER/ON_COMMON_SPINNER');
    this.fetchMyBoxList();
  },
  components: {
    EmptyData,
    ApplMenuIcon,
  },
};
</script>

<style scoped>
.v-list .v-list-item {
  border-radius: 12px;
  margin-top: 8px;
  background: #f5f6f7;
  padding-left: 0px;
  padding-right: 0px;
}
</style>
